import { render, staticRenderFns } from "./ModalEditFieldGroupArchived.vue?vue&type=template&id=2c032d97&scoped=true&"
import script from "./ModalEditFieldGroupArchived.vue?vue&type=script&lang=js&"
export * from "./ModalEditFieldGroupArchived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c032d97",
  null
  
)

export default component.exports